
import { defineComponent, computed, ref, onUnmounted } from 'vue';

export default defineComponent({
  name: 'Clock',
  setup() {
    const isPaused = ref(false);
    const elapsedTime = ref(0);
    const savedTime = ref(0);
    const timer = ref();
    const clock = computed(() => (isPaused.value ? 'play_arrow' : 'pause'));
    const formatClockTime = computed(() => {
      const date = new Date(0);
      date.setSeconds(elapsedTime.value / 1000);
      const utc = date.toUTCString();
      return utc.substr(utc.indexOf(':') - 2, 8);
    });

    const startClock = (initial = 0, resume = false) => {
      isPaused.value = false;
      if (savedTime.value && resume) elapsedTime.value = savedTime.value;
      else elapsedTime.value = initial;
      timer.value = setInterval(() => {
        elapsedTime.value += 1000;
      }, 1000);
    };

    onUnmounted(() => stopClock())

    const stopClock = () => {
      isPaused.value = true;
      savedTime.value = elapsedTime.value;
      clearInterval(timer.value);
    };

    const resetClock = () => {
      stopClock();
      elapsedTime.value = 0;
    };

    const getCurrentSeconds = () => {
      return elapsedTime.value / 1000 
    }
    
    return {
      stopClock,
      startClock,
      resetClock,
      getCurrentSeconds,
      isPaused,
      clock,
      elapsedTime,
      formatClockTime,
    };
  },
});
